const colors = {
    primary: "#6167e0",
    success: "#28C76F",
    danger: "#EA5455",
    warning: "#FF9F43",
    dark: "#1E1E1E"
};

const config = {
    theme: "semi-dark", // options[String]: 'light'(default), 'dark', 'semi-dark'
    sidebarCollapsed: false, // options[Boolean]: true, false(default)
    navbarColor: "#fff", // options[String]: HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
    navbarType: "floating", // options[String]: floating(default) / static / sticky / hidden
    footerType: "static", // options[String]: static(default) / sticky / hidden
    routerTransition: "zoom-fade", // options[String]: zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
    disableCustomizer: false, // options[Boolean]: true, false(default)
    hideScrollToTop: false, // options[Boolean]: true, false(default)
    disableThemeTour: false // options[Boolean]: true, false(default)
};

const whitelabel = {
  consulta_digital: {
    nome: "Consulta Digital",
    slogan: "Melhor negócio para seu cliente",
    logo: require("@/assets/whitelabel/consulta_digital/logo.svg"),
    logo_png_black: require("@/assets/whitelabel/consulta_digital/logo-brv.png"),
    logo_riaam: require("@/assets/whitelabel/consulta_digital/riaam.png"),
    config,
    colors
  },
  bevicred: {
    nome: "Bevicred",
    slogan: "Melhor negócio para seu cliente",
    logo: require("@/assets/whitelabel/bevicred/logo.png"),
    logo_png_black: require("@/assets/whitelabel/bevicred/logo-brv.png"),
    logo_riaam: require("@/assets/whitelabel/bevicred/riaam.png"),
    config,
    colors: {
      ...colors,
      primary: "#90A4AE"
    }
  }
}

export default whitelabel[process.env.VUE_APP_WHITELABEL_NAME];